import { useEffect } from 'react';
import warning from 'warning';
export function useDescriptionWarning(props) {
    const { ariaDescribedBy, description } = props;
    return __DEV__
        ? // eslint-disable-next-line react-hooks/rules-of-hooks
            useEffect(() => {
                warning(!(ariaDescribedBy && description), 'Passing both `aria-describedBy` and `description` to <TextArea /> will resolve in unexpected behaviour. The `aria-describedBy` attribute will be automatically set by passing a `description` prop. Please choose one or the other.');
            }, [ariaDescribedBy, description])
        : undefined;
}
